import { render, staticRenderFns } from "./ActionDispatcher.vue?vue&type=template&id=96cbc350&scoped=true&"
import script from "./ActionDispatcher.vue?vue&type=script&lang=js&"
export * from "./ActionDispatcher.vue?vue&type=script&lang=js&"
import style0 from "./ActionDispatcher.vue?vue&type=style&index=0&id=96cbc350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cbc350",
  null
  
)

export default component.exports